import { render, staticRenderFns } from "./storeDetails.vue?vue&type=template&id=3ce4aa94"
import script from "./storeDetails.vue?vue&type=script&lang=js"
export * from "./storeDetails.vue?vue&type=script&lang=js"
import style0 from "./storeDetails.vue?vue&type=style&index=0&id=3ce4aa94&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports